import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import AddControl from 'components/add_control';
import AddModal from './add_modal';
import Broker from 'bundles/apex/deals/show/brokers/broker';
import Card from 'bundles/apex/card';
import ContactDetails from 'bundles/backoffice/contacts/details';
import ContactIcon from 'bundles/backoffice/contacts/icon';
import ContactFormModalLink from 'bundles/apex/deals/show/contacts/contact/contact_form_modal_link';
import { Empty } from '@buildoutinc/blueprint-react/ui/Empty';
import { faUser } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function OutsideBrokers({ deal, transactionSideOptions }) {
  const [showAddModal, setShowAddModal] = useState();

  const commissions = deal.commissions.filter(commission => commission.outside);

  let children;
  if (commissions.length === 0) {
    children = (
      <Empty className="bg-white">
        <Empty.Media>
          <FontAwesomeIcon icon={faUser} />
        </Empty.Media>
        <Empty.Title>No brokers have been added.</Empty.Title>
      </Empty>
    );
  } else {
    children = commissions.map((commission, i) => {
      const baseLabel = 'Outside Broker';
      const sideLabel = transactionSideOptions?.find(option => option[0] === commission.transactionSide)?.[1];
      const brokerLabel = sideLabel ? `${baseLabel} - ${sideLabel}` : baseLabel;

      return (
        <Broker
          commission={commission}
          deletable
          icon={<ContactIcon contact={commission.contact} size="xl" />}
          index={i}
          key={i}
        >
          <ContactDetails
            contact={commission.contact}
            formModalLinkComponent={ContactFormModalLink}
            label={brokerLabel}
          />
        </Broker>
      );
    });
  }

  return <React.Fragment>
    <Card
      controls={<AddControl onClick={() => setShowAddModal(true)}>Add broker</AddControl>}
      label="Outside Brokers"
      verticalBody
    >
      {children}
    </Card>

    <AddModal show={showAddModal} onClose={() => setShowAddModal(false)} />
  </React.Fragment>;
}

OutsideBrokers.propTypes = {
  deal: PropTypes.shape({
    commissions: PropTypes.arrayOf(PropTypes.shape({
      contact: PropTypes.shape({
        id: PropTypes.number.isRequired,
      }),
      outside: PropTypes.bool,
    })).isRequired,
  }).isRequired,
  transactionSideOptions: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
};

const mapStateToProps = state => ({
  deal: state.deal,
  transactionSideOptions: state.options.transactionSide,
});

export default connect(mapStateToProps)(OutsideBrokers);
